<template>
    <div :ref="treeRefName" :class="treeClassName">
        <div v-for="(item,index) in convertData" :key="index" :class="[isChild ? 'process-tree-childNodes-row' : 'process-tree-roots',
        isChild && item.isLong ? 'long-with-line' : '']" :style="isChild ? {} : rootStyle">
            <div class="line" v-if="item.isLong"></div>

            <div v-if="item.colorPro" class="process-tree-node process-tree-node1" :class="isLeaftNode(item)" @click="clickName(item)">
                <p>{{ item.name }}</p>
                <p>{{ item.businessId }}</p>
            </div>
            <div v-else class="process-tree-node" :class="isLeaftNode(item)" @click="clickName(item)">
                <p>{{ item.name }}</p>
                <p>{{ item.businessId }}</p>
            </div>

            <div class="process-tree-childNodes" v-if="item.children" :class="item.children.length >1 ? 'multiply-node' :item.children.length ==0 ?'': 'single-node'">
                <processTree :data="item.children || []" :isChild="true" @clickitem="clickitem"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'processTree',
    props: {
        data: {
            type: Array,
            default: () => {
                return []
            }
        },
        isChild: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            convertData: this.convert(this.data),
            rootStyle: {}
        }
    },
    watch: {
        data() {
            this.convertData = this.convert(this.data);
        }
    },
    computed: {
        treeRefName() {
            return this.isChild ? 'childTree' : 'baseTree'
        },
        treeClassName() {
            return this.isChild ? '' : 'process-tree'
        }
    },
    methods: {
        clickName(item) {
            // console.log(item);
            this.$emit("clickitem",item)
            
        },
        clickitem(val){
            this.$emit("clickitem",val)
        },
        convert(arr) {
            return arr.map((item) => {
                if (item.children && item.children.length > 0) {
                    item.children = this.convert(item.children);
                }
                return item
            })
        },
        isLeaftNode(data) {
            return (data.children && data.children.length > 0) ? "" : "leaf-node";
        }
    }
}
</script>

<style scoped>
p{
    margin: 0;
}
.process-tree{
    width: 100%;
    overflow: auto;
}
.process-tree-roots{
    padding: 5px 0;
    display: flex;
    align-items: center;
}
.single-node::before {
    content: "";
    display: block;
    position: absolute;
    width: 13px;
    height: 3px;
    background: #d5eaff;
    left: -13px;
    top: 50%;
}

.multiply-node::before {
    content: "";
    display: block;
    position: absolute;
    width: 3px;
    height: 100%;
    background: #d5eaff;
    left: -13px;
    top: 0;
}

.process-tree-node {
    position: relative;
    padding: 6px;
    background: #ecf5ff;
    border: 1px solid #b3d8ff;
    border-radius: 5px;
    color: #409EFF;
    display: inline-block;
    cursor: pointer;
    /* text-align: center; */
    font-size: 15px;
    vertical-align: middle;
    /* height: 65px; */
}
.process-tree-node:hover{
    color: #fff;
    background: #409EFF;
}
.process-tree-node1{
    color: #fff;
    background: #409EFF;
}

.process-tree-node::after {
    content: '';
    display: block;
    width: 13px;
    height: 3px;
    background: #d5eaff;
    position: absolute;
    left: 100%;
    top: 50.7%
}

.leaf-node::after {
    display: none
}

.process-tree-childNodes {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    margin-left: 22px;
    top: 0;
}

.process-tree-childNodes>div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.multiply-node .process-tree-childNodes-row{
    display: flex;
    align-items: center;
}
.multiply-node .process-tree-childNodes-row::before {
    content: "";
    display: block;
    position: absolute;
    width: 10px;
    height: 3px;
    background: #d5eaff;
    left: -10px;
    top: 50.7%;
}

.multiply-node .process-tree-childNodes-row:first-child::after,
.multiply-node .process-tree-childNodes-row:last-child::after {
    content: '';
    position: absolute;
    display: block;
    width: 4px;
    height: 50.7%;
    background: #fff;
    left: -13px;
}

.multiply-node .long-with-line:first-child::after,
.multiply-node .long-with-line:last-child::after {
    left: -166px
}

.multiply-node .process-tree-childNodes-row:first-child::after {
    top: 0px
}

.multiply-node .process-tree-childNodes-row:last-child::after {
    bottom: -4px;
}

.process-tree-childNodes-row {
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 10px;
}

.process-tree-childNodes-row:last-child {
    margin-bottom: 0
}

.long-with-line {
    margin-left: 142px;
}

.line {
    position: absolute;
    width: 142px;
    height: 3px;
    background-color: #d5eaff;
    top: 50.7%;
    left: -161px
}
</style>
